import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const HomophoneInputErrorDialog = (props: {
  isOpenBlankDialog: boolean;
  onClick: () => void;
}) => {
  const { t } = useTranslation('admin');
  return (
    <Dialog open={props.isOpenBlankDialog}>
      <DialogTitle>{t('homophone.inputError')}</DialogTitle>
      <DialogContent>{t('homophone.fillAllFields')}</DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button onClick={props.onClick}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
export default HomophoneInputErrorDialog;
